// extracted by mini-css-extract-plugin
export default {"stadic":"Tabs_stadic__cgWQo","tabs":"Tabs_tabs__DIGKj","tab":"Tabs_tab__rpvMK","tabIcon":"Tabs_tabIcon__+fmlz","content":"Tabs_content__ppN5n","root":"Tabs_root__E3yVO"};